import { render, staticRenderFns } from "./MarketPlace.vue?vue&type=template&id=3ff04508&"
import script from "./MarketPlace.vue?vue&type=script&lang=js&"
export * from "./MarketPlace.vue?vue&type=script&lang=js&"
import style0 from "./MarketPlace.vue?vue&type=style&index=0&id=3ff04508&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports